import { ISharedItemNote } from "@/Common/Api/PortalCommunication/ISharedItemNote";
import { PortalLinkedItemType } from "../Enums/PortalLinkedItemType";
import { PortalSyncStatus } from "../Enums/PortalSyncStatus";
import { SharedItemFile } from "./SharedItemFile";
import { SharedItemMessage } from "./SharedItemMessage";

class SharedItem {
    public SharedItemId: string;
    public Status: PortalSyncStatus;
    public SharedItemType: PortalLinkedItemType;
    public EmployeeContactId: string;
    public PatientContactId: string;
    public DateCreated: Date;
    public LastStatusDate: Date;
    public CreatedByUserId: string;
    public ModifiedByUserId: string;
    public IncludeLinkedItem: boolean;
    public HasPreviouslyIncludedItem: boolean;
    public DateModified: Date;
    public Subject: string;
    public Messages: SharedItemMessage[];
    public Files: SharedItemFile[];
    public InitiatedByContactId?: string;
    public IsFlaggedForReview?: boolean;
    public ArchivedByUserId?: string | null;
    public DateArchived?: string | null;
    public DateReadByUser: Date;
    public Notes: ISharedItemNote[];
    public SharedItemCategoryId: string;
    public CanPatientReplyWithMessage: boolean;

    // UI property
    public static readonly SubjectMaxLength = 400;

    constructor(fields?: Partial<SharedItem>) {
        Object.assign(this, fields);

        for (let message of this.Messages || [])
            message.tmpIdForUI = SharedItemMessage.getTempIdForUi(message);
    }
}

export { SharedItem };
